import React, { useRef, useState } from "react";
import EventIcon from "@mui/icons-material/Event";
import { Box, Button, Divider, Grid, TextField, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import "react-datepicker/dist/react-datepicker.css";

import { useEffect } from "react";
import { getEndOfMonth, getLastDateOfMonth, getStartOfMonth, payloadDateFormat } from "../../../utils/commonUtils";

import DownloadIcon from '@mui/icons-material/Download';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import SalesSummary from '../../../common/salarySummery';
import { getFirstDateOfCurrentMonthPayloadFormate, getFirstDateOfMonth, getLastDateOfCurrentMonthPayloadFormat } from '../../../utils/commonUtils';

import DateComponent from "./dateComponent";
import { callbackHandlerGetPurchase } from "../../purchase/purchaseFunctionParamter";
import { getPurchase } from "../../purchase/purchaseCustomApiHandler";
import { getPurchaseDetail, getPurchaseDetailXlsx } from "../../purchase/purchaseApi";
import { datePickerOnChange, datePickerOnChangeEnd } from "../../purchase/purchaseDateFunctions";
import TableReport from "./table";
import { useNavigate } from "react-router";
import { ArrowBackIcon } from "../../../common/icon";

const data = [
  { category: 'Hair Wash', items: 11, amount: '₹ 2443.38', percent: '56.09%' },
  { category: 'Head Massage', items: 21, amount: '₹ 2443.38', percent: '77.00%' },
  { category: 'Manicure', items: 1, amount: '₹ 2443.38', percent: '44.00%' },
  { category: 'Basic Facial', items: 3, amount: '₹ 2443.38', percent: '33.00%' },
  { category: 'Shaving', items: 4, amount: '₹ 2443.38', percent: '33.00%' },
  { category: 'Detox Treatment', items: 5, amount: '₹ 2443.38', percent: '33.00%' },
  { category: 'Eyelash Lifting', items: 23, amount: '₹ 2443.38', percent: '44.00%' },
];

export default function PurchaseReportT({ data }) {

  const [open, setOpen] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [counterSales, setCounterSales] = useState();
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 1000,
  });
  const [numberOfRecords, setNumberOfRecords] = useState(1);
 const navigate = useNavigate();

  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [startDateFormat, setstartDateFormat] = useState(
    getFirstDateOfCurrentMonthPayloadFormate()
  );

  const [endDate, setEndDate] = useState(
    getLastDateOfCurrentMonthPayloadFormat()
  );
  let payload = {
    rawMaterialId: 0,
    quantity: 0,
    amount: 0,
    description: "",
    price: 0,
  };
  const [purchaseItem, setPurchaseItem] = useState(payload);

  const [searchItem, setSearchItem] = useState([]);
  const datePickerRef = useRef();
  const datePickerRef2 = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [totalAmount, setTotalAmount] = useState(0);
  const [purchaseItems, setPurchaseItems] = useState([]);

  const callbackHandlerGetPurchaseob = callbackHandlerGetPurchase(
    getPurchase,
    {
      fromDate: startDateFormat,
      toDate: endDate,
      search: "string",
      page: 1,
      pageSize: pagination.pageSize,
    },
    setNumberOfRecords,
    setPurchaseItems,
    getPurchaseDetail,
    setTotalAmount
  );
  useEffect(() => {
    callbackHandlerGetPurchaseob.getPurchase.callback({
      ...callbackHandlerGetPurchaseob.getPurchase.parameter,
      param: {
        fromDate: startDateFormat,
        toDate: endDate,
        search: "string",
        page: 1,
        pageSize: pagination.pageSize,
      },
    });
    // getPurchase(
    //   {
    //     fromDate: startDateFormat,
    //     toDate: endDate,
    //     search: "string",
    //     page: 1,
    //     pageSize: 4,
    //   },
    //   setNumberOfRecords,
    //   setPurchaseItems,
    //   getPurchaseDetail, setTotalAmount
    // );
  }, [startDateFormat, endDate]);
  useEffect(() => {
    console.log("datE ", getFirstDateOfCurrentMonthPayloadFormate());
    callbackHandlerGetPurchaseob.getPurchase.callback({
      ...callbackHandlerGetPurchaseob.getPurchase.parameter,
      param: {
        fromDate: startDateFormat,
        toDate: endDate,
        search: "string",
        page: 1,
        pageSize: pagination.pageSize,
      },
    });

  }, []);

  const handleChange = (event, value) => {
    callbackHandlerGetPurchaseob.getPurchase.callback({
      ...callbackHandlerGetPurchaseob.getPurchase.parameter,
      param: {
        fromDate: startDateFormat,
        toDate: endDate,
        search: "string",
        page: value,
        pageSize: pagination.pageSize,
      },
    });

    setPagination({
      ...pagination,
      page: value,
    });
  };

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/CounterSales/GetOverAllCounterSalesDetailsXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getPurchaseDetailXlsx(param, { responseType: "blob" });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  return (
    <Box
      sx={{
        py: "17px",
        px: { sm: "30px", xs: "20px" },
        background: "#ede9ff",
        minHeight: "100vh",
      }}
    >
      <Grid container spacing={2} alignItems="center">
  <Grid container alignItems="center" spacing={2}>
        {/* Back Icon */}
        <Grid item>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/home")}
          />
        </Grid>
        <Grid item xs>
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              paddingLeft: "20px",
              borderRadius: 2,
              color: "#01008B", // optional text color
              textAlign: "left",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "18px" },
              }}
            >
              {" "}
              Purchase Report{" "}
            </Typography>
          </Box>
        </Grid>
        </Grid>
        {/* Date Input */}
        <Grid
          item
          xs={12}
          sm={9}
          md={10}
          sx={{
            // p:"10px 0px",paddingRight:"10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DateComponent
            date={date}
            setDate={setDate}
            displayEndDate={displayEndDate}
            setDisplayEndDate={setDisplayEndDate}
            dateFocused={dateFocused}
            setDateFocused={setDateFocused}
            SelectedStartDate={SelectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            SelectedEndDate={SelectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
            startDateFormat={startDateFormat}
            setstartDateFormat={setstartDateFormat}
          />
        </Grid>

        {/* Download Button */}

        {/* Download Button */}
        <Grid
          item
          md={2}
          sm={3}
          xs={12}
          sx={{
            padding: "0px",
          }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={() =>
              downloadXLSXFile({
                fromDate: startDateFormat,
                toDate: endDate,
                search: "string",
                page: 1,
                pageSize: pagination.pageSize,
              })
            }
            sx={{ height: "40px", backgroundColor: "#14008B", padding: "0px" }}
            endIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Grid>

        {/* Total Sale */}
      </Grid>

      <Grid
        container
        sx={{
          paddingTop: "10px",
        }}
      >
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            color="primary"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Total Bills:{" "}
            <span
              style={{
                fontWeight: "700",
                marginLeft: "10px",
              }}
            >
              {numberOfRecords}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            color="primary"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Total Bills Amount:{" "}
            <span
              style={{
                fontWeight: "700",
                marginLeft: "10px",
              }}
            >
              {" "}
              {totalAmount?.toFixed(2)}
            </span>
          </Typography>
        </Grid>
      </Grid>

      {/* Table */}
      <Box mt={4} sx={{ borderRadius: 2, background: "#fff" }}>
        <TableReport
          salesData={[]}
          colName={[
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Items",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Amount",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
          ]}
          data={purchaseItems ?? []}
        />
      </Box>
    </Box>
  );
}
